define('meetings/meetings-menu/meetings-menu',['require','exports','module','knockout','plugins/router','scheduler/scheduler-container','durandal/app'],function (require, exports, module) {
    var ko = require('knockout');
    var router = require('plugins/router');
    var Scheduler = require('scheduler/scheduler-container');
    var app = require('durandal/app');

    module.exports = function () {
        var self = this;

        self.isScheduleButtonShown = ko.observable(true);

        self.showScheduler = function () {
            self.isScheduleButtonShown(false);
            Scheduler.show(null, null, true);
        };

        app.on('scheduleModal:shown', function () {
            self.isScheduleButtonShown(true);
        });

        self.activate = function (activationData) {
            self.navigationModel = activationData.navigationModel;
            self.shiftMenuTabs = activationData.shiftMenuTabs;
            self.composeJoinLink = activationData.composeJoinLink;

            self.pullMenuTabs = ko.computed(function () {
                if (router.activeInstruction()) {
                    return router.activeInstruction().fragment !== 'meetings/past' && self.composeJoinLink();
                }
                return undefined;
            });
        };
    };
});

